import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../../utils/apiConfig';


const DELIMITER = ';'; // puedes cambiarlo a ',' u otro

const CiudadDropDown = ({ selectedObra, setSelectedObra, ubicacionesPermitidas, disabled }) => {
  const [options, setOptions] = useState([]);

  // Construye el string seleccionado según permitidas/opciones
  const buildSelectedString = (opciones, permitidas) => {
    if (!opciones?.length) return '';

    const canon = (s) => String(s || '').trim();
    const canonLower = (s) => canon(s).toLowerCase();

    const optionMap = new Map(
      opciones.map(o => [canonLower(o.value), canon(o.value)]) // lower -> original
    );

    let values = [];

    if (permitidas?.length) {
      // Intersección en el orden de 'permitidas'
      const unique = new Set();
      for (const p of permitidas) {
        const key = canonLower(p);
        if (optionMap.has(key) && !unique.has(key)) {
          unique.add(key);
          values.push(optionMap.get(key));
        }
      }
      // Si no hubo coincidencias, usa todas las opciones
      if (values.length === 0) {
        values = Array.from(optionMap.values());
      }
    } else {
      // Sin permitidas: usa todas las opciones
      values = Array.from(optionMap.values());
    }

    // Quita vacíos, dedup y une con el delimitador
    const dedup = Array.from(new Set(values.map(canon))).filter(Boolean);
    return dedup.join(`${DELIMITER} `); // añade espacio tras delimitador para legibilidad
  };

  useEffect(() => {
    const fetchUbicaciones = async () => {
      try {
        let url = getApiUrl('api/ubicaciones');
        if (ubicacionesPermitidas && ubicacionesPermitidas.length > 0) {
          url += '?ubicacionesPermitidas=' + ubicacionesPermitidas.join(',');
        }
        const res = await fetch(url);
        const data = await res.json();

        // Poblaciones únicas
        const poblacionesUnicas = Array.from(
          new Set(
            data
              .map(item => (item.Poblacion || '').trim())
              .filter(Boolean)
          )
        );

        const opciones = poblacionesUnicas.map((poblacion, idx) => ({
          value: poblacion,
          label: poblacion,
          id: poblacion + idx,
        }));

        setOptions(opciones);

        // Calcula el string seleccionado y sincroniza si hace falta
        const computed = buildSelectedString(opciones, ubicacionesPermitidas);
        const actual = (selectedObra?.Poblacion || '').trim();

        // 🔥 SOLO actualizar Poblacion si es diferente, pero NUNCA borrar Subdivision existente
        if (computed && computed !== actual) {
          setSelectedObra(prev => ({ 
            ...prev, 
            Poblacion: computed 
            // NO tocar Subdivision aquí - mantener el valor existente
          }));
        }
      } catch (error) {
        console.error('Error al obtener las poblaciones:', error);
      }
    };
    fetchUbicaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ubicacionesPermitidas]);

  const poblacion = selectedObra?.Poblacion || '';

  return (
    <div className="hidden">
      <label className="block mb-1 text-sm font-medium text-gray-700 truncate">Población*</label>
      <div
        className={`p-2 border rounded bg-white text-sm ${disabled ? 'opacity-60' : ''}`}
        title={`Valores asignados automáticamente (delimitador: "${DELIMITER}")`}
      >
        {poblacion || '—'}
      </div>
    </div>
  );
};

export default CiudadDropDown;
